'use es6';

import { OrderedMap, Record } from 'immutable';
import * as Actions from 'FormsUI/actions/Ticket';
import * as RequestStates from 'FormsCommonComponents/lib/RequestState';
const INIT_STATE = new Record({
  pipelines: new OrderedMap(),
  stages: new OrderedMap(),
  fetchPipelineRequestState: RequestStates.NOT_REQUESTED
})();
function setRequestState(state, newRequestState) {
  return state.set('fetchPipelineRequestState', newRequestState);
}
function receivePipelines(state, pipelines) {
  return state.set('pipelines', pipelines);
}
function receivePipelineStages(state, stages) {
  return state.set('stages', stages);
}
export function ticket(state = INIT_STATE, action) {
  switch (action.type) {
    case Actions.REQUEST_PIPELINES:
      return setRequestState(state, RequestStates.REQUESTED);
    case Actions.RECEIVE_PIPELINES:
      return receivePipelines(state, action.payload);
    case Actions.RECEIVE_PIPELINE_STAGES:
      return receivePipelineStages(state, action.payload);
    case Actions.SUCCEEDED_GETTING_PIPELINES:
      return setRequestState(state, RequestStates.SUCCEEDED);
    case Actions.FAILED_GETTING_PIPELINES:
      return setRequestState(state, RequestStates.FAILED);
    default:
      return state;
  }
}